// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FloatingTools__icon___T4v90 {
    align-items: center;
    background: rgba(4, 10, 13, 0.46);
    border: 1px solid rgba(194, 151, 65, 0.28);
    border-radius: 999px;
    box-sizing: border-box;
    display: flex;
    font-weight: bold;
    height: 34px;
    justify-content: center;
    margin: 0 0 8px;
    overflow: hidden;
    position: relative;
    transition: background 120ms ease, border-color 120ms ease, box-shadow 120ms ease, transform 120ms ease;
    width: 34px;
}

.FloatingTools__icon___T4v90 > span {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
}

.FloatingTools__icon___T4v90 > span > span {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    margin: 0;
    width: 100%;
}

.FloatingTools__icon___T4v90:hover {
    background: rgba(16, 29, 34, 0.78);
    border-color: rgba(226, 181, 85, 0.68);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.18), 0 6px 14px rgba(0, 0, 0, 0.28);
    color: rgba(212, 229, 223, 0.96) !important;
    transform: translateY(-1px);
}

.FloatingTools__icon___T4v90:last-child {
    margin-bottom: 0;
}

.FloatingTools__icon___T4v90.FloatingTools__disabled___APueI {
    color: rgba(167, 190, 188, 0.28) !important;
    opacity: 0.48;
}

.FloatingTools__icon___T4v90.FloatingTools__disabled___APueI a,
.FloatingTools__icon___T4v90.FloatingTools__disabled___APueI button,
.FloatingTools__icon___T4v90.FloatingTools__disabled___APueI .glyphicon {
    color: rgba(167, 190, 188, 0.28) !important;
    cursor: default;
}

.FloatingTools__icon___T4v90.FloatingTools__disabled___APueI:hover {
    background: rgba(4, 10, 13, 0.46);
    border-color: rgba(194, 151, 65, 0.28);
    box-shadow: none;
    color: rgba(167, 190, 188, 0.28) !important;
    transform: none;
}

.FloatingTools__icon___T4v90 a:focus-visible,
.FloatingTools__icon___T4v90 button:focus-visible {
    border-radius: 8px;
    outline: 2px solid #79d9ee;
    outline-offset: 4px;
}

.FloatingTools__icon___T4v90 a,
.FloatingTools__icon___T4v90 button {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    text-decoration: none;
    width: 100%;
}

.FloatingTools__active___a5fVB {
    color: #61ff61;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `FloatingTools__icon___T4v90`,
	"disabled": `FloatingTools__disabled___APueI`,
	"active": `FloatingTools__active___a5fVB`
};
module.exports = ___CSS_LOADER_EXPORT___;
